export default {
  props: {
    roomId: { required: false },
    profileId: { required: false },
  },
  data() {
    return {
      open: false,
      media: [],
    };
  },
  watch: {},
  methods: {
    send(mediaId) {
      axios
        .post(this.roomId ? zRoute('ajax.chat2.rooms.images.store', this.roomId) : zRoute('ajax.chat2.profiles.images.store', this.profileId), {
          media_id: mediaId,
        })
        .then((response) => {
          this.emitMessage(response.data.data);
          this.emitHide();
        });
    },
    emitMessage(message) {
      this.$emit('message', message);
    },
    emitHide() {
      this.$emit('hide');
    },
    load() {
      axios
        .get(zRoute('ajax.user.media.index', { public: true }))
        .then((response) => {
          this.media = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    this.load();
  },
};
